import { render, staticRenderFns } from "./ReasonInputApp12_14.vue?vue&type=template&id=835bbf74&scoped=true&"
import script from "./ReasonInputApp12_14.vue?vue&type=script&lang=ts&"
export * from "./ReasonInputApp12_14.vue?vue&type=script&lang=ts&"
import style0 from "./ReasonInputApp12_14.vue?vue&type=style&index=0&id=835bbf74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835bbf74",
  null
  
)

export default component.exports